import { render } from "./IconChartBar.vue.js?vue&type=template&id=2367843e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconChartBar.vue?vue&type=template&id=2367843e"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__